import { ref } from "vue";

/**
 * Guards list-page state against out-of-order async responses (OT-4928):
 * when requests can overlap (e.g. rapid searches with no server-side
 * cancellation), a slower older response can resolve after a newer one and
 * overwrite fresher state. Call start() before issuing a request to get a
 * token, then check isLatest(token) before applying that request's result -
 * a token that is no longer the latest belongs to a superseded request and
 * its response should be discarded.
 */
export function useLatestRequestGuard(): {
  start: () => number;
  isLatest: (token: number) => boolean;
} {
  const latestToken = ref(0);

  function start(): number {
    latestToken.value += 1;
    return latestToken.value;
  }

  function isLatest(token: number): boolean {
    return token === latestToken.value;
  }

  return { start, isLatest };
}
